/** Предобработка изображения: макс. 946px, макс. 2 MB */
const MAX_DIMENSION = 946;
const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB (результат после сжатия)
export const MAX_INPUT_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB (макс. размер входа)

export const preprocessImage = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => (img.src = e.target.result);
    img.onload = () => {
      const k = Math.min(MAX_DIMENSION / img.width, MAX_DIMENSION / img.height, 1);
      const w = Math.floor(img.width * k);
      const h = Math.floor(img.height * k);

      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);

      const tryCompress = (quality) =>
        new Promise((res, rej) => {
          canvas.toBlob(
            (blob) =>
              blob
                ? res(
                    new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), {
                      type: 'image/jpeg',
                      lastModified: Date.now(),
                    }),
                  )
                : rej(new Error('Не удалось сконвертировать')),
            'image/jpeg',
            quality,
          );
        });

      const compressWithQuality = async (quality) => {
        const result = await tryCompress(quality);
        if (result.size <= MAX_FILE_SIZE_BYTES || quality <= 0.3) {
          return result;
        }
        const nextQuality = Math.max(0.3, quality - 0.15);
        return compressWithQuality(nextQuality);
      };

      tryCompress(0.92)
        .then((result) => {
          if (result.size <= MAX_FILE_SIZE_BYTES) {
            resolve(result);
          } else {
            compressWithQuality(0.85).then(resolve).catch(reject);
          }
        })
        .catch(reject);
    };
    img.onerror = () => reject(new Error('Ошибка загрузки'));
    reader.readAsDataURL(file);
  });

/** Сжимает Blob или data URL до лимитов и возвращает base64 для отправки */
export const getCompressedBase64 = async (blobOrDataUrl) => {
  let blob;
  if (blobOrDataUrl instanceof Blob) {
    blob = blobOrDataUrl;
  } else {
    const res = await fetch(blobOrDataUrl);
    blob = await res.blob();
  }
  const file = new File([blob], 'image.jpg', { type: blob.type || 'image/jpeg' });
  const compressed = await preprocessImage(file);
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result.split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(compressed);
  });
};
